<template>
	<div>
		<div class="swiper-index-banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in lista" :key="index" @click="goPlay">
					<img :src="item.url" v-if="item.type==1" />
					<template v-else>
						<template v-if="headerShow">
							<video :src="item.url" :autoplay="true" muted loop :ref="'video'+index" webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
						</template>
						<template v-else>
							<video :src="item.url"  muted loop :ref="'video'+index" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
						</template>
					</template>
					<div class="swiper-slide-dw">
						<div :class="activeIndex==index?' ':''" style="animation-duration: 1s;" v-if="locale=='zh'">
							<div class="swiper-slide-dw-name">
								<div v-for="(itema,indexa) in item.other.bigTitle" :key="indexa">
									{{itema.title}}
								</div>
							</div>
							<div class="swiper-slide-dw-cen">
								<div v-for="(itema,indexa) in item.other.smallTitle" :key="indexa" :style="{
								height:itema.title?'':'20px',
								letterSpacing: '0.1em'
							}">
									{{itema.title}}
								</div>
							</div>
							<div class="swiper-slide-dw-cenen">{{item.cenEn}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props:{
			list:{
				typeof:Array,
				default:[]
			}
		},
		data() {
			return {
				activeIndex:0,
				locale:'zh',
				lista:[]
			}
		},
		mounted() {
			let t=this;
			this.locale=this.$i18n.locale;
			
		},
		methods: {
			setList(e){
				this.lista=e;
				let t=this;
				// autoplay: {
				// 	delay: 5000,
				// 	disableOnInteraction: false,
				// },
				this.$nextTick(function(){
					t.$refs['video0'][0].play()
					const mySwiper = new this.$swiper('.swiper-index-banner', {
						// 方向
						direction: 'horizontal',
						// 自动播放
						autoplay: false,
						on: {
							slideChangeTransitionStart(e){
								  t.activeIndex = this.activeIndex;
								  t.$refs['video' + t.activeIndex][0].play()
							},
							  
						  },
					});
				})
			},
			goPlay(){
				let t=this;
				t.$refs['video' + t.activeIndex][0].play()
				t.$bus.$emit('overLoad')
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-index-banner{
		overflow: hidden;
		height: 500px;
	}
.swiper-slide{
	position: relative;
	img{
		width: 100%;
		height: 500px;
		object-fit: cover;
	}
	video{
		width: 100%;
		height: 500px;
		object-fit: cover;
	}
	.swiper-slide-dw{
		position: absolute;
		top:0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		width: 100%;
		height: 500px;
		background-color: rgba(0,0,0,0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		.swiper-slide-dw-name{
			font-size: 3em;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #FFFFFF;
			text-align: center;
			width:900px;
			margin: 0 auto;
		}
		.swiper-slide-dw-cen{
			margin-top: 55px;
			font-size: 1em;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #FFFFFF;
			margin-bottom: 20px;
			width: 900px;
			word-wrap: break-word;
			word-break: break-all;
			text-align: center;
		}
		.swiper-slide-dw-cenen{
			font-size: 35px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #FFFFFF;
			width: 900px;
			word-wrap: break-word;
			word-break: break-all;
			text-align: center;
		}
	}
}

@media screen and (max-width:1200px) {
		.swiper-slide-dw-name {
			font-size: 30px !important;
			padding: 0 30px !important;
			color: red;
		}

		.swiper-slide-dw-cen {
			font-size: 16px !important;
			word-wrap: break-word;
			word-break: break-all;
			width: 100% !important;
			padding: 0 10px !important;
			box-sizing: border-box;
		}

		.swiper-slide-dw-cenen {
			font-size: 14px !important;
		}
	}
</style>